import { createContext } from "react";

const RegistroContext = createContext();

export default RegistroContext;
